// useActiveUserId — the owner id of the ACTIVE Dexie database, as React
// state. `null` means no database is open yet (cold boot before the
// AuthProvider's user effect has run, or signed out). A route that reads
// Dexie on mount must key its query on this value and render its loading
// state while it is null; keying on `user.id` from the auth context is
// wrong, because the user can be known before the database is open —
// that gap is exactly the cold-load race on /app/progress.
import { useSyncExternalStore } from "react";
import { getActiveUserId, onActiveDbChange } from "../services/db";

export function useActiveUserId(): string | null {
  return useSyncExternalStore(onActiveDbChange, getActiveUserId, () => null);
}
